import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { MENU_CURATION_TASK_HISTORY_QUERY } from '../graphql/queries'
import { FETCH_MENU_CURATION_TASK_HISTORY } from '../redux/action-types'

const useMenuCurationTaskHistoryQuery = (
  menuCurationTaskId,
  { pageSize, currentPage } = {},
) => {
  const dispatch = useDispatch()

  const { isLoading, error, data } = useSelector(
    store => store.menuCurationTasks.menuCurationTask.history,
  )

  const refetch = useCallback(
    (filtersParam, paginationParam) =>
      apolloService.query({
        query: MENU_CURATION_TASK_HISTORY_QUERY,
        variables: {
          filters: filtersParam,
          pagination: paginationParam,
        },
        dispatch,
        action: FETCH_MENU_CURATION_TASK_HISTORY,
      }),
    [dispatch],
  )

  useEffect(() => {
    refetch(
      {
        menuCurationTaskId,
      },
      { pageSize, currentPage },
    )
  }, [refetch, pageSize, currentPage, menuCurationTaskId])

  return { isLoading, error, data }
}

export default useMenuCurationTaskHistoryQuery
